import { render, staticRenderFns } from "./AdvisoryBoard.vue?vue&type=template&id=ad9dd058&scoped=true&"
import script from "./AdvisoryBoard.vue?vue&type=script&lang=js&"
export * from "./AdvisoryBoard.vue?vue&type=script&lang=js&"
import style0 from "./AdvisoryBoard.vue?vue&type=style&index=0&id=ad9dd058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9dd058",
  null
  
)

export default component.exports